import { render, staticRenderFns } from "./Hae-koulutuskumppaniksi-kiitos.vue?vue&type=template&id=22d93c6b&"
import script from "./Hae-koulutuskumppaniksi-kiitos.vue?vue&type=script&lang=js&"
export * from "./Hae-koulutuskumppaniksi-kiitos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports